import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ticketStatus } from '@/const';
import { cancelPart } from '@/api';
import QrcodeVue from 'qrcode.vue';
export default {
  props: {
    tickets: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    id: {
      type: Number,
      default: 0
    },
    isChanged: {
      type: Boolean,
      default: false
    },
    isshowInfo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ticketStatus: ticketStatus
    };
  },
  components: {
    QrcodeVue: QrcodeVue
  },
  computed: {
    allowUserPartCancel: function allowUserPartCancel() {
      return this.$store.state.projectConfig.allow_user_part_cancel;
    }
  },
  methods: {
    refundPart: function refundPart(index) {
      var params = {};
      params.id = this.id;
      params.ticketIds = [this.tickets[index].id];
      this.refundOrder(params);
    },
    refundOrder: function refundOrder(params) {
      var _this = this;

      this.$confirm('确认取消此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        cancelPart(params).then(function (res) {
          _this.$message({
            type: 'success',
            message: '已提交退单申请!'
          });
        });
      }).catch(function () {// on cancel
      });
    }
  }
};